import { useEffect, useState } from 'react';
import { getProviders } from 'models/provider/controllers/provider.controller';
import { Provider } from 'models/provider/interfaces/provider.interface';

const useProviders = (onlyActive = true, forceRefresh = false): Provider[] => {
	const [providers, setProviders] = useState<Provider[]>([]);

	useEffect(() => {
		getProviders(onlyActive, forceRefresh)
			.then(setProviders)
			.catch(() => {});
	}, [onlyActive]);

	return providers;
};

export default useProviders;
